import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { home_template } from "../components/templates/home_template";
import {header} from "./header";

declare var ko: any;
declare var page: any;

export class home extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected home: home_template;

    protected getModuleName(){
        return "home";
    }

    buildContent() : Array<Element>{

        this.home = new home_template( "homePage", this.viewModel, this );
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Home");

        return [ this.home.build()];
    }

    public fillPage() : void{
        this.setupSideNav()
    }

    protected setupSideNav() {
        if (document.querySelector(".btn-sidebar") !== null) {
            document.querySelector(".btn-sidebar").classList.remove('is-closed')
        }
        else if (document.querySelector(".btn-sidebar-pwa") !== null) {
            document.querySelector(".btn-sidebar-pwa").classList.remove('is-closed')
        }
        document.querySelector(".sidenav").classList.remove('is-closed', 'is-desable')
        document.querySelector(".main-header").classList.remove('is-desable')
        document.querySelector("#closedHeader").classList.remove('is-closed')
        document.querySelector("#header").classList.remove('is-closed')
        document.querySelector("#closedContent").classList.remove('is-closed')
    }
}



// WEBPACK FOOTER //
// ./js/modules/home.ts